// import React from "react";
// import Spacing from "../Spacing";


// export const ProductsDetailMainSection = ({ description, department, imgUrl }) => {
//   return (
//     <div className="product-container">
//       {/* Product Image Section */}
//       <Spacing md="85" />
//       <div className="product-image">
//         <div className="image-card">
//           <img src={imgUrl} alt="Doctor" className="product-img" />
//           <h3 className="department-title">{department}</h3>
//         </div>
//       </div>

//       {/* Product Details Section */}
//       <div className="product-details">
//         <div className="details">
//           <h2>Description</h2>
//           <p>{description}</p>
//         </div>

//         <div className="application-list">
//           <h2>Applications</h2>
//           <p>The Mercury Hyper-Hypothermia Unit can be used for surgeries like:</p>
//           <ul>
//             <li>Arterial/ventricular Septal Defects</li>
//             <li>CABG (Coronary Artery Bypass Grafting)</li>
//             <li>Heart valve replacement (MVR, AVR & PVR)</li>
//             <li>Congenital Surgeries</li>
//             <li>Hypothermic Surgeries</li>
//           </ul>
//         </div>
//       </div>
//     </div>
//   );
// };



import React from 'react';
import Spacing from '../Spacing';



export default function ProductsDetailMainSection({
  bgUrl,
  imgUrl,
  name,
  department,
  designation,
  description,
  Applications

}) {
  return (
    <div className="cs_doctor_details">
      <div
        className="cs_doctor_details_bg cs_bg_filed"
        style={{
          backgroundImage: `url(${bgUrl})`,
        }}
      />
      <Spacing md="85" />
      <div className="container">
        <div className="row">
          <div className="col-lg-5">
            <div className="cs_single_doctor overflow-hidden cs_radius_20 p-5">
              <img src={imgUrl} alt="Doctor" className="w-100 cs_radius_20 "  />
              <h3 className="cs_white_color cs_accent_bg mb-0 text-center cs_semibold cs_fs_24" style={{
                    padding:"14px 15px"
                  }}>
                {department}
              </h3>
            </div>



          </div>
          <div className="col-lg-6   position-relative">
            <Spacing md="55" />
            <h1 className="cs_fs_120 mb-0 cs_semibold"  style={{
                    fontSize:"45px",
                    color:"#3f48cc"
                  }}> {name}</h1>

            <Spacing md="32" />
            <p className="mb-0 cs_heading_color">{description}</p>

            <Spacing md="32" />
            <h4 className="underline"> {Applications[0]?.applicationsTitle}</h4>
            <p style={Applications[0]?.description?.style}>
              {Applications[0]?.description?.text || "Description not available."}
            </p>
            <div className="application-list">
              {Applications[0]?.applicationList?.length > 0 ? (
                <ul>
                  {Applications[0].applicationList.map((app, index) => (
                    <li key={index}>{app}</li>
                  ))}
                </ul>
              ) : (
                <p>No applications available.</p>
              )}
            </div>
            {/* {Applications.applicationList?.length > 0 && (
    <div className="application-list">
      <ul>
        {Applications.applicationList.map((app, index) => (
          <li key={index}>{app}</li>
        ))}
      </ul>
    </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}
